var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.88144 16C0.759633 15.9998 0.639203 15.9742 0.527807 15.9249C0.416411 15.8756 0.316488 15.8037 0.23439 15.7137C0.150808 15.6245 0.087029 15.5186 0.0472361 15.4029C0.00744312 15.2873 -0.00746497 15.1646 0.00348907 15.0428L0.218587 12.6769L10.1552 2.74108L13.2605 5.84636L3.32653 15.7813L0.961333 15.9965C0.934773 15.9989 0.908112 16.0001 0.88144 16ZM13.8804 5.22548L10.7759 2.1202L12.6381 0.257561C12.7196 0.175911 12.8164 0.111136 12.923 0.0669417C13.0296 0.0227475 13.1438 0 13.2592 0C13.3746 0 13.4888 0.0227475 13.5954 0.0669417C13.702 0.111136 13.7988 0.175911 13.8804 0.257561L15.7425 2.1202C15.8241 2.20176 15.8889 2.29862 15.9331 2.40523C15.9773 2.51184 16 2.62611 16 2.74152C16 2.85693 15.9773 2.9712 15.9331 3.07782C15.8889 3.18443 15.8241 3.28128 15.7425 3.36284L13.8813 5.2246L13.8804 5.22548Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.00d442130ee1a57ae95b1206ecc636ff.svg";
export { ForwardRef as ReactComponent };